import * as uuid from 'uuid';

import {
  API_URL as BASE_API_URL,
  CONVEYACING_LINKED_ENTITY_TYPE,
  CONVEYACING_PRODUCT_TYPE,
  CONVEYACING_SOURCE_TYPE,
} from '@funnels/constants';
import { MOCK_DATA } from '@funnels/mockdata';
import { ServerConveyancingCreateIntentRequest, ServerConveyancingFetchRequest } from '@funnels/types';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';
const API_URL = `${BASE_API_URL}/v1`;

export function fetchConveyancingByPropertyId(assetId: string): Promise<any> {
  // TODO: Add mock data for conveyancing
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: { id: uuid.v4() } });
  }

  return axios.get(`${API_URL}/conveyancing/internal/property/${assetId}`).then((res) => res.data);
}

export function fetchConveyancingIntent(payload: ServerConveyancingFetchRequest): Promise<any> {
  // TODO: Add mock data for conveyancing
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: { id: uuid.v4() } });
  }

  return axios
    .get(`${API_URL}/nmp/intent/product/CONVEYANCING/customer/${payload.customerId}/entity/${payload.property.id}`)
    .then((res) => res.data);
}

export function createConveyancingIntent(payload: ServerConveyancingCreateIntentRequest): Promise<any> {
  // TODO: Add mock data for conveyancing
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: { id: uuid.v4() } });
  }

  const requestBody = {
    customerId: payload.customerId,
    linkedEntityId: payload.assetId,
    linkedEntityType: CONVEYACING_LINKED_ENTITY_TYPE,
    productType: CONVEYACING_PRODUCT_TYPE,
    intent: payload.intent,
    sourceId: payload.applicationId,
    sourceType: CONVEYACING_SOURCE_TYPE,
  };

  return axios.post(`${API_URL}/nmp/intent`, requestBody).then((res) => res.data);
}

export default { createConveyancingIntent, fetchConveyancingIntent, fetchConveyancingByPropertyId };
